import type { ClassNameValue } from 'tailwind-merge'

export function cn(...classes: ClassNameValue[]): string {
  let joined = ''
  for (const c of classes) {
    if (!c) continue
    joined += joined ? ' ' + c : c
  }

  return joined
}
